import { render, staticRenderFns } from "./ProductsSoldTogetherItem.vue?vue&type=template&id=17b17d62"
import script from "./ProductsSoldTogetherItem.vue?vue&type=script&lang=js"
export * from "./ProductsSoldTogetherItem.vue?vue&type=script&lang=js"
import style0 from "./ProductsSoldTogetherItem.vue?vue&type=style&index=0&id=17b17d62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports